import http from "../config/axios";

interface OpeningHours {
  early_morning?: string;
  end_morning?: string;
  early_afternoon?: string;
  end_afternoon?: string;
  nights_start?: string;
  nights_end?: string;
}

export async function restaurantsAll(limit = 100, offset = 0) {
  try {
    const response = await http.get("/restaurant/list", {
      params: {
        limit,
        offset,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching restaurants:", error);
    throw error;
  }
}

export async function getRestaurantById(restaurantId: any) {
  try {
    const response = await http.get(`/restaurant/detail/${restaurantId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar informações do restaurante:", error);
    throw error;
  }
}

export async function updateRestaurantById(
  restaurantId: any,
  restaurantData: any
) {
  try {
    const response = await http.patch(
      `/restaurant/update/${restaurantId}`,
      restaurantData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar o restaurante:", error);
    throw error;
  }
}

export async function listRestaurantCalendars(limit = 100, offset = 0) {
  try {
    const response = await http.request({
      method: "GET",
      url: "/restaurant_calendar/list",
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        limit,
        offset,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar os calendários dos restaurantes:", error);
    throw error;
  }
}

export async function updateRestaurantCalendarById(
  restaurantCalendarId: any,
  calendarData: any
) {
  try {
    const response = await http.patch(
      `/restaurant_calendar/update/${restaurantCalendarId}`,
      calendarData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar o calendário do restaurante:", error);
    throw error;
  }
}

export async function addProductRestaurant({
  restaurantId,
  product,
}: {
  restaurantId: string;
  product: any;
}) {
  const url = `/restaurants/product/${restaurantId}`;
  try {
    const response = await http.request({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      url,
      data: product,
    });

    return response.data;
  } catch (error: any) {
    console.error("Error making the request:", error);
    throw new Error(
      `Add product failed: ${error.message || "Some error occurred"}`
    );
  }
}

export async function update_Restaurant_Working(
  restaurantId: string,
  isWorking: boolean
): Promise<any> {
  const url = `/restaurants/restaurant-working/${restaurantId}?is_working=${isWorking}`;

  const dataBody = {
    isWorking: isWorking,
  };

  try {
    const response = await http.put(url, dataBody, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("Error making the request:", error);
    throw new Error(
      `Update working failed: ${error.message || "Some error occurred"}`
    );
  }
}

export async function update_Opening_Hour(
  restaurantId: string,
  day: string,
  requestBody: OpeningHours
): Promise<any> {
  const url = `/restaurants/opening_hour/${restaurantId}?day=${day}`;
  const dataBody = {
    opening_hour: requestBody,
  };

  try {
    const response = await http.put(url, dataBody, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log("response.data-->", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Erro ao fazer a requisição:", error);
    throw new Error(
      `Update hours failed: ${error.message || "Some error occurred"}`
    );
  }
}
